// Module
var code = "<div class=\"root-component\"> <spond-header></spond-header> <div class=\"container\"> <group-link></group-link> </div> </div> ";
// Exports
export default code;